import React, { Component, Fragment } from "react";

import { connect } from 'react-redux';
import * as actionCreaters from "../../Store/actions/index";
import MainToolBar from "../../Component/Navigation/MainToolBar/MainToolBar";
import Spinner from "../../Component/UI/spinner/Spinner";
import WishView from "../../Component/WishList/WishList";
import ContactNow from "../../Component/ContactNow/ContactNow";

class WishList extends Component {

    state = {
        searchInput: '',
        showAuth: false,
        authMode: 'signIn'
    }

    // componentDidMount() {
    //     const token = localStorage.getItem('idToken');
    //     this.props.onGetWihsList(token)
    // }

    searchInputHandler = (value) => {
        this.setState({
            searchInput: value
        })
    }

    reLoadSearchPageHandler = () => {
        //  console.log('tes')
    }

    showAuthHandler = (mode, kepShowing) => {
        if (kepShowing) {
            this.setState({ showAuth: true })
        } else {
            this.setState((prevState) => {
                return { showAuth: !prevState.showAuth }
            })
        }
        if (mode === 'signUp') {
            this.setState({
                authMode: 'signUp'
            })
        }
        else if (mode === 'signIn') {
            this.setState({
                authMode: 'signIn'
            })
        }
        else if (mode === 'passwordReset') {
            this.setState({
                authMode: 'passwordReset'
            })
        }
        else if (mode === 'verifyEmail') {
            this.setState({
                authMode: 'verifyEmail'
            })
        }
    }

    render() {
        return (
            <Fragment>
                <MainToolBar searchInput={(value) => { this.searchInputHandler(value) }}
                    searchInputValue={this.state.searchInput}
                    props={{ ...this.props }}
                    reLoadSearchPage={this.reLoadSearchPageHandler}
                    showAuthHandler={this.showAuthHandler}
                    user={this.props.user}
                />
                {this.props.wishListLoading ?
                    <Spinner />
                    :
                    this.props.wishList ?
                        <WishView
                            wishList={this.props.wishList}
                            routProp={{ ...this.props }}
                            RemoveItemFromWishList={this.props.onRemoveItemFromWishList}
                            removing={this.props.removing}
                            toggelContactNow={this.props.onToggelContactNow} />
                        :
                        <Spinner />
                }
                <ContactNow />
            </Fragment>
        );
    }
}

const mapStateToPrpos = state => {
    return {
        user: state.Auth.user,
        wishList: state.WishList.whishListItems,
        wishListLoading: state.WishList.wishListLoading,
        removing: state.WishList.removing
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onGetWihsList: (token) => { dispatch(actionCreaters.getWishList(token)) },
        onRemoveItemFromWishList: (itemId, token) => { dispatch(actionCreaters.removeItemFromUserWishList(itemId, token)) },
        onToggelContactNow: (id, name, phone) => { dispatch(actionCreaters.toggelContactShow(id, name, phone)) }
    }

}

export default connect(mapStateToPrpos, mapDispatchToProps)(WishList);

